import { useState } from 'react';
import { Platform } from 'react-native';

interface HoverProps {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

interface UseHoverEffectResult {
  isHovered: boolean;
  hoverProps: HoverProps;
}

export function useHoverEffect(): UseHoverEffectResult {
  const [isHovered, setIsHovered] = useState(false);

  if (Platform.OS !== 'web') {
    return { isHovered: false, hoverProps: {} };
  }

  const hoverProps: HoverProps = {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  };

  return { isHovered, hoverProps };
}
